export default __webpack_public_path__ + "static/media/polygon_white_blue.6e78061c.svg";